<script setup lang="ts">
/** TMP089 — Letter of Allotment (OTC). 실제 변수: company, letter_date, cosec_name, cosec_address,
 *  capitalized_amount, creditor_name, total_new_shares, share_price, allottee loop, Signers.
 *  토글: has_constitution. */
import { computed, inject } from 'vue';
import { OTC_DOC_CTX } from './otcContext';
import OtcDocVarField from './OtcDocVarField.vue';
import OtcDocHead from './parts/OtcDocHead.vue';
import OtcAllotteeTable from './parts/OtcAllotteeTable.vue';
import OtcSigners from './parts/OtcSigners.vue';

const ctx = inject(OTC_DOC_CTX)!;
const hasConstitution = computed(() => ctx.flag('has_constitution'));
</script>

<template>
  <div class="allot-doc">
    <OtcDocHead />

    <p class="doc-p"><b>Date:</b> <OtcDocVarField field-key="letter_date" /></p>

    <p class="doc-p">
      The Secretary<br />
      <OtcDocVarField field-key="cosec_name" /><br />
      <OtcDocVarField field-key="cosec_address" />
    </p>

    <p class="doc-p">Dear Sir,</p>
    <p class="doc-p"><b><u>Allotment of Shares</u></b></p>

    <p class="doc-p">
      We wish to inform you that we propose to capitalise the total amount of
      RM<OtcDocVarField field-key="capitalized_amount" />, being the amount due to
      <OtcDocVarField field-key="creditor_name" /> into
      <OtcDocVarField field-key="total_new_shares" /> ordinary shares of
      RM<OtcDocVarField field-key="share_price" /> each in the Company to the following party(ies): -
    </p>

    <p class="doc-lbl-title">Non-Cash Shares</p>
    <OtcAllotteeTable shares-header="No. of Shares to be Allotted" />

    <p class="doc-p" style="margin-top:12px">
      Kindly proceed with the allotment of shares in accordance with the
      <span class="doc-toggle" title="Constitution / Articles of Association" @click="ctx.toggleFlag('has_constitution')">{{ hasConstitution ? 'Constitution' : 'Articles of Association' }}</span>
      of the Company.
    </p>

    <p class="doc-p" style="margin-top:26px">Yours faithfully,</p>
    <OtcSigners var-key="letter" />
  </div>
</template>
